import mmrImg from "../Img/mmr-city.png"; 

const MMRAdvantagePage = () => {
  const points = [
    {
      title: "Economic Powerhouse",
      desc: "The Mumbai Metropolitan Region (MMR) stands as one of India’s fastest-growing economic hubs, driving tremendous opportunities for residential and commercial development.",
    },
    {
      title: "Robust Financing Demand",
      desc: "High demand for both residential and commercial financing creates a dynamic market with competitive lending options.",
    },
    {
      title: "Diverse Clientele",
      desc: "We serve salaried professionals, self-employed individuals, and entrepreneurs—understanding the unique needs of each segment.",
    },
    {
      title: "Local Presence",
      desc: "Our established MMR footprint ensures quick response times, reliable service, and a deep understanding of local market dynamics.",
    },
  ];

  return (
    <section className="mmr-page">
      {/* Left Side Image */}
      <div className="mmr-page-left">
        <img src={mmrImg} alt="Mumbai Skyline" />
      </div>

      {/* Right Side Content */}
      <div className="mmr-page-right">
        <h2 className="mmr-page-title">
          The Mumbai Metropolitan <br /> Region Advantage
        </h2>

        <div className="mmr-page-cards">
          {points.map((item, index) => (
            <div key={index} className="mmr-page-card">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MMRAdvantagePage;
